'use strict'

define ['./brokerage.scss'], () ->
  ($scope, $rootScope, $state, $stateParams, $http, $window, Flash, RENTAPPLICATION_API_URL) ->
    
    $scope.submit = (brk_name, brk_email, brk_phone, brk_message) ->
      $scope.submitting = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/send_brokerage/",
        brk_name: brk_name
        brk_email: brk_email
        brk_phone: brk_phone
        brk_message: brk_message
      .then ->
        Flash.create('success', 'Thank you for your interest. We will contact you shortly!' , 9000)
        $scope.brk_name = $scope.brk_email = $scope.brk_phone = $scope.brk_message = ""
      .catch (r) ->
        Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.', 9000)
      .finally ->
        $scope.submitting = false



// WEBPACK FOOTER //
// ./components/home/brokerage/brokerage.coffee